
export default {
  // 屏幕
  SCREEN_WIDTH: typeof document !== 'undefined' ? document.documentElement.clientWidth : 0,
  SCREEN_HEIGHT: typeof document !== 'undefined' ? document.documentElement.clientHeight : 0,
  // H5竖屏设计稿
  H5_DESIGN_WIDTH: 750,
  H5_DESIGN_HEIGHT: 1334,
  // H5横屏设计稿背景图ihpnex
  H5_H_DESIGN_BG_WIDTH: 1624,
  H5_H_DESIGN_BG_HEIGHT: 750,
  // H5横屏居中编辑区域
  H5_H_DESIGN_WIDTH: 1334,
  H5_H_DESIGN_HEIGHT: 750,
  // PC设计稿背景图
  PC_DESIGN_BG_WIDTH: 1920,
  PC_DESIGN_BG_HEIGHT: 1080,
  // PC居中编辑区域
  PC_DESIGN_WIDTH: 1366,
  PC_DESIGN_HEIGHT: 768,
};
